var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "previous-step",
          class: {
            "active-previous-step": !!_vm.idSelectedCategory(
              _vm.selectedCategory
            )
          },
          on: {
            click: function($event) {
              _vm.back(_vm.idSelectedCategory(_vm.selectedCategory))
            }
          }
        },
        [
          _c("div", { staticClass: "icon-container-previous-step" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.idSelectedCategory(_vm.selectedCategory),
                    expression: "idSelectedCategory(selectedCategory)"
                  }
                ],
                staticClass: "icon-previous-step"
              },
              [_vm._v(" < ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "previous-step-name" }, [
            _vm._v(_vm._s(_vm.nameSelectedCategory(_vm.selectedCategory)))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.subcategoriesList(_vm.selectedCategory).length === 0 &&
      !_vm.selectedCategoryWithProducts(_vm.selectedCategory) &&
      _vm.categoryDataLoadFlag
        ? _c("div", { staticClass: "help-message" }, [
            _vm._v("Загрузка ...\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.subcategoriesList(_vm.selectedCategory).length === 0 &&
      !_vm.selectedCategoryWithProducts(_vm.selectedCategory) &&
      !_vm.categoryDataLoadFlag
        ? _c("div", { staticClass: "help-message" }, [
            _vm._v("Список категорий продуктов пуст!\n    ")
          ])
        : _c(
            "div",
            _vm._l(_vm.subcategoriesList(_vm.selectedCategory), function(
              value
            ) {
              return _c(
                "div",
                {
                  staticClass: "subcategory",
                  on: {
                    click: function($event) {
                      return _vm.selectCategory(
                        value.idCategory,
                        value.nameCategory
                      )
                    }
                  }
                },
                [_c("div", [_vm._v(_vm._s(value.nameCategory))])]
              )
            }),
            0
          ),
      _vm._v(" "),
      _c("ProductsSidebar", {
        staticClass: "mt-30",
        attrs: {
          idSelectedCategory: _vm.idSelectedCategory(_vm.selectedCategory)
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }